import { Routes, Route } from "react-router-dom";
import Loader from "../../Utils/Loader";

import Dashboard from "../Layout/Users/Dashboard/Dashboard";
import Services from "../Layout/Users/Service/Service";
import Trades from "../Layout/Users/Trades/Trade";
import TradeMcx from "../Layout/Users/Trades/TradeMcx";
import Basket from "../Layout/Users/Basket/Basket";
import PastPerformance from "../Layout/Users/PastPerformance/PastPerformance";
import ReferEarn from "../Layout/Users/ReferEarn/Refer";
import Coupon from "../Layout/Users/Coupon/Coupon";
import Faq from "../Layout/Users/Faq/Faq";
import PaymentHistory from "../Layout/Users/PaymentHistory/PaymentHistory";
import Subscription from "../Layout/Users/Subscription/Subscription";
import Privacy from "../Layout/Users/Privacy/Privacy";
import Terms from "../Layout/Users/TermsCondition/Terms";
import Profiles from "../Layout/Users/Profile/Profiles";
import Demat from "../Layout/Users/Demat/Demat";
import Cash from "../Layout/Users/PastPerformance/Cash";
import Future from "../Layout/Users/PastPerformance/Future";
import Option from "../Layout/Users/PastPerformance/Option";
import Userkyc from "../Layout/Users/Profile/Kyc";
import HelpDesk from "../Layout/Users/HelpDesk/HelpDesk";
import BrokerReponse from "../Layout/Users/Trades/BrokerReponse";
import BasketDetail from "../Layout/Users/Basket/BasketDetail";
import Notification from "../Layout/Users/Notification/Notification";
import Broadcast from "../Layout/Users/Broadcast/Broadcast";
import News from "../Layout/Users/News/News";
import NewsDetail from "../Layout/Users/News/NewsDetail";
import Blogs from "../Layout/Users/Blogs/Blogs";
import BasketStockList from "../Layout/Users/Basket/BasketStockList";
import RebalanceHistory from "../Layout/Users/Basket/RebalanceHistory";
import BasketResponse from "../Layout/Users/BasketResponse/BasketResponse";
import Wallet from "../Layout/Users/Wallet/Wallet";
import Payments from "../Layout/Users/Basket/Payments";
import RebalanceStock from "../Layout/Users/Basket/RebalanceStock";
import Disclaimer from "../Layout/Users/Discliamer/Disclaimer";
import BlogDetail from "../Layout/Users/Blogs/BlogDetail";
import ThankYou from "../Layout/Users/Basket/ThankYou";
import Strategy from "../Layout/Users/Strategy/Strategy";
import Cart from "../Layout/Users/Cart/Cart";
import HelpDeskView from "../Layout/Users/HelpDesk/HelpDeskView";
import ClientBrokerResponse from "../Layout/Users/Trades/ClientBrokerResponse";
import ServiceCart from "../Layout/Users/Service/ServiceCart";
import BasketCart from "../Layout/Users/Basket/BasketCart";

export default function App() {
  return (
    <Routes>

      <Route path="/dashboard" element={<Dashboard />} />

      <Route path="/basket" element={<Basket />} />
      <Route path="/basketcart" element={<BasketCart />} />

      <Route path="/trades" element={<Trades />} />

      <Route path="/mcx-trades" element={<TradeMcx />} />

      <Route path="/service" element={<Services />} />
      <Route path="/servicecart" element={<ServiceCart />} />


      <Route path="/past-performance" element={<PastPerformance />} />
      <Route path="/refer-earn" element={<ReferEarn />} />
      <Route path="/coupons" element={<Coupon />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/payment-history" element={<PaymentHistory />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/terms-conditions" element={<Terms />} />
      <Route path="/profile" element={<Profiles />} />
      <Route path="/demat" element={<Demat />} />
      <Route path="/past-performance/cash" element={<Cash />} />
      <Route path="/past-performance/future" element={<Future />} />
      <Route path="/past-performance/option" element={<Option />} />
      <Route path="/kyc" element={<Userkyc />} />
      <Route path="/help-desk" element={<HelpDesk />} />
      <Route path="/broker-response" element={<BrokerReponse />} />
      <Route path="/basketdetail" element={<BasketDetail />} />
      <Route path="/notification" element={<Notification />} />
      <Route path="/broadcast" element={<Broadcast />} />
      <Route path="/news" element={<News />} />
      <Route path="/newsdetail" element={<NewsDetail />} />
      <Route path="/basketstocklist" element={<BasketStockList />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blogdetail" element={<BlogDetail />} />
      <Route path="/rebalanceHistory/:id" element={<RebalanceHistory />} />
      <Route path="/basket-response" element={<BasketResponse />} />
      <Route path="/rebalancestock/:id" element={<RebalanceStock />} />
      <Route path="/wallet" element={<Wallet />} />
      <Route path="/payment" element={<Payments />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/strategy" element={<Strategy />} />
      <Route path="/thankyou" element={<ThankYou />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/help-desk-view/:id" element={<HelpDeskView />} />
      <Route path="/broker-response-deatil" element={<ClientBrokerResponse />} />

    </Routes>
  );
}
